<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10o9oPW/images/wsu-gallagher-cover5.jpg?1724424474352" alt="This image is the cover for the book Rust Belt Reporter, Great Lakes Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rust Belt Reporter, Great Lakes Books
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>The decline and resurgence of a storied Midwestern city as seen through the eyes of a seasoned journalist, union activist, and Detroit devotee.</b> </p><p>Reflecting on his life's work as a reporter, including thirty-two years with the <i>Detroit Free Press</i>, journalist John Gallagher merges memoir with an insider's account of the challenges facing Detroit and other Rust Belt cities, as well as the tensions inside local newsrooms throughout the country. <br/>Beginning with Gallagher's first job in 1974 in Chicago, with subsequent stops in Rochester and Syracuse, New York, this witty and exciting chronicle details his experiences behind the scenes, breaking major news stories over the decades that followed. From the early days when reporters called in stories on pay phones to today's revenue-generating affiliate commissions, his memoir serves as a documentary of this turbulent journalistic era. Gallagher's career intersected many notable events, including the troubled Kilpatrick administration, newspaper strikes, the federal bailout of automotive companies, the bankruptcy of Detroit, and the exceptional Grand Bargain struck to save the city—all while noting the increasingly important roles nonprofits and private companies play in city politics and newsrooms, for better and for worse. <br/>Alongside sage insight into the difficulties and decline of traditional media, Gallagher's experience and advice inspire hope, often underscoring and celebrating the surprising and happy reinvention of heartland cities like Detroit. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Gallagher, Stephen Henderson, Thomas A. Klug
      </h2>
      
      <p class="authorDescription body article"><p>John Gallagher is a veteran journalist, author, and authority on urban affairs, particularly relating to Rust Belt cities. Educated at DePaul University in Chicago and Columbia University in New York, he joined the <i>Detroit Free Press</i> in 1987 as an urban affairs writer and continued reporting there for thirty-two years. A resident of Detroit, Gallagher continues to work as a public speaker, author, and freelance journalist.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4dc4e81c